import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import IconPrescribers from 'components/icons/IconPrescribers';

const styles = () => ({
  root: {
    height: 330,
  },
  iconPrescribers: {
    width: 90,
    height: 100,
  },
});

const PrescribersTableEmpty = ({ classes }) => (
  <Grid
    className={classes.root}
    container
    direction="column"
    justify="center"
    alignItems="center"
    spacing={24}
  >
    <Grid item>
      <IconPrescribers className={classes.iconPrescribers} />
    </Grid>
    <Grid item>
      <Typography variant="subheading" color="secondary">
        Unfortunately, there are no such prescribers
      </Typography>
    </Grid>
  </Grid>
);

PrescribersTableEmpty.propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    iconPrescribers: PropTypes.string.isRequired,
  }).isRequired,
};

export default withStyles(styles)(PrescribersTableEmpty);



// WEBPACK FOOTER //
// ./src/components/settings/PrescribersTable/PrescribersTableEmpty.js